import { Injectable, inject } from "@angular/core";
import { IsWalletAvailableService } from "@app/core/wallet/domain/service/is-wallet-available.service";
import { catchError, Observable, of } from "rxjs";


@Injectable({
    providedIn: "root"
})
export class IsWalletAvailableUseCase {
    private readonly isWalletAvailableService = inject(IsWalletAvailableService);

    execute(): Observable<boolean> {
        return this.isWalletAvailableService.execute().pipe(
            // In case of error, we don't know if the wallet should be available or not
            // so we hide it for prevention
            catchError(() => {
                return of(false);
            })
        );
    }
}